module.exports = __webpack_public_path__ + "img/D201503_5.11eb307b.jpg";